import ChooseDestination from './ChooseDestination';
import ConfirmSelection from './ConfirmSelection';
import AwaitingAction from './AwaitingAction';
import CopySuccess from './CopySuccess';
import CopyError from './CopyError';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import Validation from './Validation';
import { jsx as _jsx } from "react/jsx-runtime";
function AssetCopierPanelBody() {
  const {
    currentStep
  } = useAssetCopierContext();
  switch (currentStep) {
    case 'CHOOSE_DESTINATION':
      return /*#__PURE__*/_jsx(ChooseDestination, {});
    case 'VALIDATION':
      return /*#__PURE__*/_jsx(Validation, {});
    case 'CONFIRM_SELECTION':
      return /*#__PURE__*/_jsx(ConfirmSelection, {});
    case 'AWAITING_ACTION':
      return /*#__PURE__*/_jsx(AwaitingAction, {});
    case 'SUCCESS':
      return /*#__PURE__*/_jsx(CopySuccess, {});
    case 'ERROR':
      return /*#__PURE__*/_jsx(CopyError, {});
    default:
      return null;
  }
}
export default AssetCopierPanelBody;